export default __webpack_public_path__ + "static/media/climao.9988f68f.png";